/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { ApplicationDocument } from './ApplicationDocument'
import {
  ApplicationDocumentFromJSON,
  ApplicationDocumentFromJSONTyped,
  ApplicationDocumentToJSON,
} from './ApplicationDocument'

/**
 *
 * @export
 * @interface Documents
 */
export interface Documents {
  /**
   *
   * @type {Array<ApplicationDocument>}
   * @memberof Documents
   */
  Registered?: Array<ApplicationDocument>
  /**
   *
   * @type {Array<ApplicationDocument>}
   * @memberof Documents
   */
  FE?: Array<ApplicationDocument>
  /**
   *
   * @type {Array<ApplicationDocument>}
   * @memberof Documents
   */
  MKTU?: Array<ApplicationDocument>
  /**
   *
   * @type {Array<ApplicationDocument>}
   * @memberof Documents
   */
  EOS?: Array<ApplicationDocument>
  /**
   *
   * @type {Array<ApplicationDocument>}
   * @memberof Documents
   */
  EGR?: Array<ApplicationDocument>
  /**
   *
   * @type {Array<ApplicationDocument>}
   * @memberof Documents
   */
  CompletedEOS?: Array<ApplicationDocument>
}

/**
 * Check if a given object implements the Documents interface.
 */
export function instanceOfDocuments(value: object): value is Documents {
  return true
}

export function DocumentsFromJSON(json: any): Documents {
  return DocumentsFromJSONTyped(json, false)
}

export function DocumentsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Documents {
  if (json == null) {
    return json
  }
  return {
    Registered:
      json['Registered'] == null
        ? undefined
        : (json['Registered'] as Array<any>).map(ApplicationDocumentFromJSON),
    FE:
      json['FE'] == null
        ? undefined
        : (json['FE'] as Array<any>).map(ApplicationDocumentFromJSON),
    MKTU:
      json['MKTU'] == null
        ? undefined
        : (json['MKTU'] as Array<any>).map(ApplicationDocumentFromJSON),
    EOS:
      json['EOS'] == null
        ? undefined
        : (json['EOS'] as Array<any>).map(ApplicationDocumentFromJSON),
    EGR:
      json['EGR'] == null
        ? undefined
        : (json['EGR'] as Array<any>).map(ApplicationDocumentFromJSON),
    CompletedEOS:
      json['CompletedEOS'] == null
        ? undefined
        : (json['CompletedEOS'] as Array<any>).map(ApplicationDocumentFromJSON),
  }
}

export function DocumentsToJSON(value?: Documents | null): any {
  if (value == null) {
    return value
  }
  return {
    Registered:
      value['Registered'] == null
        ? undefined
        : (value['Registered'] as Array<any>).map(ApplicationDocumentToJSON),
    FE:
      value['FE'] == null
        ? undefined
        : (value['FE'] as Array<any>).map(ApplicationDocumentToJSON),
    MKTU:
      value['MKTU'] == null
        ? undefined
        : (value['MKTU'] as Array<any>).map(ApplicationDocumentToJSON),
    EOS:
      value['EOS'] == null
        ? undefined
        : (value['EOS'] as Array<any>).map(ApplicationDocumentToJSON),
    EGR:
      value['EGR'] == null
        ? undefined
        : (value['EGR'] as Array<any>).map(ApplicationDocumentToJSON),
    CompletedEOS:
      value['CompletedEOS'] == null
        ? undefined
        : (value['CompletedEOS'] as Array<any>).map(ApplicationDocumentToJSON),
  }
}
